import React from 'react';

import { Grid, Typography } from '@material-ui/core';

import InputField from '~/components/Formik/FormFields/InputField';
import InputFieldMask from '~/components/Formik/FormFields/InputFieldMask';
import { zipMask } from '~/pages/utils/formikFieldsMask';

interface Props {
  formField: {
    zipCode: any;
    street: any;
    number: any;
    complement: any;
    district: any;
    city: any;
    state: any;
  };
}

const AddressForm: React.FC<Props> = ({ formField }) => {
  const {
    zipCode,
    street,
    number,
    complement,
    district,
    city,
    state,
  } = formField;

  return (
    <>
      <Typography variant="h6" gutterBottom>
        Endereço
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <InputFieldMask
            mask={zipMask}
            name={zipCode.name}
            label={zipCode.label}
            placeholder="     -   "
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <InputField name={street.name} label={street.label} fullWidth />
        </Grid>
        <Grid item xs={12} md={6}>
          <InputField name={number.name} label={number.label} fullWidth />
        </Grid>
        <Grid item xs={12} md={6}>
          <InputField
            name={complement.name}
            label={complement.label}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <InputField name={district.name} label={district.label} fullWidth />
        </Grid>
        <Grid item xs={12} md={6}>
          <InputField name={city.name} label={city.label} fullWidth />
        </Grid>
        <Grid item xs={12} md={6}>
          <InputField name={state.name} label={state.label} fullWidth />
        </Grid>
      </Grid>
    </>
  );
};

export default AddressForm;
